import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid col-span-1 lg:grid-cols-5 gap-8" }
const _hoisted_2 = { class: "lg:col-span-2 space-y-6 lg:text-right lg:p-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Building a Team", -1)
const _hoisted_4 = { class: "space-y-2" }
const _hoisted_5 = { class: "lg:text-end" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Surround yourself with people that you can trust and who share the same work ethic as you do. That was our approach which kept us going even with ongoing challenges and errors which brought quite some headaches. ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("In the end we made it work - welcome to ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = { class: "lg:col-span-3 grid grid-cols-2 lg:grid-cols-3" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "pt-4 text-center" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "text-neutral-200/50 uppercase text-xs leading-none" }

import ContainerSection from "@/components/section/ContainerSection.vue";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeTeam',
  setup(__props) {

const team = [
    {
        name: "Blockschmidt",
        role: "3D artist and Founder",
        image: require("@/assets/images/team/blockschmidt.png"),
    },
    {
        name: "Aaron",
        role: "3D Environment Artist",
        image: require("@/assets/images/team/aaron.png"),
    },
    {
        name: "Videokidd",
        role: "3D Animation Artist",
        image: require("@/assets/images/team/videokidd.png"),
    },
    {
        name: "Chris",
        role: "Typedesign",
        image: require("@/assets/images/team/chris.png"),
    },
    {
        name: "Flori",
        role: "UI/UX Designer",
        image: require("@/assets/images/team/flori.png"),
    },
    {
        name: "Fabi",
        role: "Engineering Lead",
        image: require("@/assets/images/team/fabi.png"),
    },
];

return (_ctx: any,_cache: any) => {
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createBlock(ContainerSection, { id: "team" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createVNode(DripversityIcon, { class: "text-dripversity" }),
              _hoisted_9
            ])
          ])
        ])), [
          [
            _directive_animate,
            void 0,
            void 0,
            { stagger: true }
          ]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(team, (member, i) => {
            return _createElementVNode("article", {
              key: member.name,
              class: _normalizeClass(["flex flex-col p-4 border-b border-l border-neutral-800", [
                        (i + 1) % 3 === 0 && 'lg:border-r',
                        (i + 1) % 2 === 0 && 'border-r lg:border-r-0',
                        i < 2 && 'border-t',
                        i < 3 && 'lg:border-t',
                        i >= 6 - 2 && 'border-b',
                        i >= 6 - 3 && 'lg:border-b',
                    ]])
            }, [
              _createElementVNode("img", {
                class: "w-full aspect-square w-full rounded",
                src: member.image,
                alt: member.name
              }, null, 8, _hoisted_11),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h5", _hoisted_13, _toDisplayString(member.name), 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString(member.role), 1)
              ])
            ], 2)
          }), 64))
        ])), [
          [
            _directive_animate,
            void 0,
            void 0,
            { stagger: true }
          ]
        ])
      ])
    ]),
    _: 1
  }))
}
}

})